export default "__VITE_ASSET__8a896820__"